export function handleTargetCategory(list) {
  console.log('list :>> ', list)
  Array.isArray(list) &&
    list.forEach((item) => {
      if (item.children && item.children.length === 0) {
        item.children = null
      } else {
        handleTargetCategory(item.children)
      }
    })
}
